import React, { useEffect, useState } from "react";
import {
  Avatar,
  Card,
  Form,
  Input
} from "antd";

import { GlobalOutlined } from "@ant-design/icons";

const EventVenue = ({ data }) => {

  const [address, setAddress] = useState({});

  const formItemLayout = {
    labelCol: {
      span: 4,
    },
    wrapperCol: {
      span: 14,
    },
  };

  const { Meta } = Card;

  const formName = "EventVenueForm";
  const [form] = Form.useForm();

  useEffect(() => {
    loadVenue()
  }, [])

  const loadVenue = () => {
      form.setFieldsValue({
        name: data.name,
        type: data.venueType
      })
      setAddress(data.eventAddress);
  }

  return (
    <>
      <Form
        {...formItemLayout}
        name={formName}
        form={form}
        layout="horizontal"
        disabled
      >
        <Form.Item
          name="name"
          label="Name"
        >
          <Input name="name" />
        </Form.Item>
        <Form.Item
          name="type"
          label="Type"
        >
          <Input name="name" />
        </Form.Item>
        <Form.Item
          name="address"
          label="Address"
        >

          <Card
          name="address"
            style={{
              width: "100%",
              marginTop: 16,
              justifyContent: "center",
              marginBottom: 10,
              backgroundColor: "rgb(250 250 250)",
              borderBlockStyle: "solid",
              borderColor: "#CCC",
            }}
          >
            <Meta
              avatar={<Avatar icon={<GlobalOutlined />} />}
              title={"Address"}
              description={`${address.street} ${address.cityOrTown} ${address.province} ${address.postalCode}, ${address.country}`}
            />
          </Card>
        </Form.Item>
      </Form>

    </>
  );
};

export default EventVenue;
